export default __webpack_public_path__ + "static/taegeun.moon.kyungjune.kim-3d1380c29e8fb4435467dea2aace1ab1.jpeg";